import { render, staticRenderFns } from "./YoutubeSearch.vue?vue&type=template&id=438a3595&"
import script from "./YoutubeSearch.vue?vue&type=script&lang=ts&"
export * from "./YoutubeSearch.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports